import { isValidPhoneNumber } from 'libphonenumber-js';
import useTranslation from '~/client/hooks/i18n/useTranslation';

const useFormPhoneNumber = (required: boolean) => {
  const errorMessage = useTranslation('errors.INVALID_PHONE');

  const validatePhoneNumber = (phone: string) => {
    const isValidPhone =
      isValidPhoneNumber(phone ?? '') || (!required && !phone);

    return isValidPhone || errorMessage;
  };

  return { validatePhoneNumber };
};

export default useFormPhoneNumber;
